import React from 'react'
import styled from "styled-components"
import device from "@src/utils/device"
import Layer from "@components/layer"
import YouTube from 'react-youtube';
import axios from "axios"


const Projects = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

const Project = styled.figure`
  flex: 1 1 500px;
  height: auto;
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;

  @media ${device.tablet} {
    flex: 1 1 380px;
  }
  @media ${device.laptop} {
    flex: 1 1 400px;
  }
  @media ${device.laptopL} {
    flex: 1 1 500px;
  }
`
const Ghost = styled.div`
  flex: 1 1 500px;
  height: 0px;

  @media ${device.tablet} {
    flex: 1 1 380px;
  }
  @media ${device.laptop} {
    flex: 1 1 400px;
  }
  @media ${device.laptopL} {
    flex: 1 1 500px;
  }
`

const Image = styled.img`
  height: 100%;
  width: 100%;
  display: block;
  object-fit: cover;
  margin: 0;
  transition: transform 1s;

  &:hover {
    transform: scale(1.1);
  }
`

const Caption = styled.figcaption`
  display: none;
`

const YouTubeStyle = styled(YouTube)`
  width: 100vw;
  height: 30vh;

  @media ${device.laptop} {
    width: 68vw;
    height: 60vh;
  }
`

class Portfolio extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLayerOpen: false,
      videoId: '',
      data: [],
    }
    this.onClose = this.onClose.bind(this)
  }

  setMovies(movies) {
    const videoIds = movies.map( items => items.videoId ).sort((a, b) => a.index - b.index);
    const apiKey = 'AIzaSyBE-2le02npRCgDgur7b8jsR2d4XTFP_bA';
    const part = 'snippet,contentDetails,statistics';
    const url = `https://www.googleapis.com/youtube/v3/videos?part=${part}&id=${videoIds}&key=${apiKey}`;

    axios(url)
      .then(json => {
        this.setState({ data: json.data.items })
      })
      .catch(error => {
        console.log(error)
      })
  }

  componentDidMount() {
    const url = `${process.env.GATSBY_API_URL}movies.json`;

    axios(url)
      .then(movies => {
        this.setMovies( movies.data.playlist );
      })
      .catch(error => {
        console.log(error)
      })
  }

  onClose() {
    this.setState({isLayerOpen: false})
  }

  onItemClick(videoId) {
    this.setState({videoId: videoId})
    this.setState({isLayerOpen: true})
  }

  render() {
    const opts = {
      playerVars: {
        modestbranding: 1,
        autoplay: 1,
        controls: 1,
        fs: 1,
        rel: 0,
        showinfo: 0,
      }
    };

    return (
      <>
        <Projects>
          {
            this.state.data.map( project => {

            const { id, snippet } = project
            const { title, thumbnails } = snippet
            const { medium, high, standard, maxres } = thumbnails
            let urlHD;
            let urlMQ;

            if (maxres) {
              urlHD = maxres.url
            } else if (standard) {
              urlHD = standard.url
            } else if (high) {
              urlHD = high.url
            } else if (medium) {
              urlHD = medium.url
            } else {
              urlHD = thumbnails.default.url
            }

            if (medium) {
              urlMQ = medium.url
            } else {
              urlMQ = urlHD = thumbnails.default.url
            }

              return (
                <Project key={id} onClick={ () => this.onItemClick(id) }>
                  <Image
                    src={urlHD}
                    sizes="(min-width: 480px) 100vw, (max-width: 480px) 25vw"
                    srcSet={`${urlMQ} 320w, ${urlHD} 1280w`}
                    alt={title}
                    title={title}
                  />
                  <Caption>
                    <div>{title}</div>
                    <div>{id}</div>
                  </Caption>
                </Project>
              )
            })
          }

          <Ghost />
          <Ghost />
          <Ghost />
          <Ghost />
          <Ghost />
        </Projects>
        <Layer open={this.state.isLayerOpen} close={ this.onClose }>
          <YouTubeStyle
            videoId={this.state.videoId}
            opts={opts}
          />
        </Layer>
      </>
    )
  }
}

export default Portfolio
